<div class="flex-column gap">
    @if (showStartDate()) {
        <div class="flex pt-2">
            <app-date-input
                [form]="innerForm"
                id="dtstart"
                [label]="labelStartDate() | translate"
                [disabled]="disabled()"
            ></app-date-input>
        </div>
    }

    @let freqIsDailyOrGreater = innerForm.value.freq !== null && [RRuleFrequency.YEARLY, RRuleFrequency.MONTHLY, RRuleFrequency.WEEKLY, RRuleFrequency.DAILY].includes(innerForm.value.freq!);
    @if (freqIsDailyOrGreater) {
        <div class="flex gap-small align-items-center">
            <div>{{ 'inputs.rrule.enum.frequency.label' | translate }} {{ 'inputs.rrule.repeatEvery' | translate }}</div>

            <app-number-input
                [form]="innerForm"
                id="interval"
                [showLabel]="false"
            ></app-number-input>

            <app-select-input
                [form]="innerForm"
                id="freq"
                [staticOptions]="rruleFrequencyEnumOptions"
                [showLabel]="false"
                valueKey="value"
                [showClear]="true"
            ></app-select-input>
        </div>

        @switch (innerForm.value.freq) {
            @case (RRuleFrequency.WEEKLY) {
                <div class="flex gap-small align-items-center">
                    <span>{{ 'inputs.rrule.repeatOnWeekDay' | translate }}</span>
                    <app-multi-select-input
                        #multiselectByWeekDay
                        [form]="innerForm"
                        id="byweekday"
                        [staticOptions]="rruleWeekDayEnumOptions"
                        [showLabel]="false"
                        valueKey="value"
                        [showClear]="true"
                    >
                        <ng-template #item let-item>
                            {{ 'inputs.rrule.enum.weekDay.' + RRuleWeekDay[item.value] | translate }}
                        </ng-template>
                        <ng-template #selectedItems let-items>
                            <div class="flex gap-small" style="min-height: 1.5rem;">
                                @for (item of items; track $index) {
                                    <p-chip [removable]="true"
                                        (onRemove)="multiselectByWeekDay.removeItem($event, item)">
                                        <div>{{ item.name }}</div>
                                    </p-chip>
                                }
                            </div>
                        </ng-template>
                    </app-multi-select-input>
                </div>
            }
            @case (RRuleFrequency.MONTHLY) {
                <div class="grid-container">
                    <app-radio-input
                        [form]="innerForm"
                        id="type"
                        layout="vertical"
                        class="fh-2"
                        [staticOptions]="monthlyTypeOptions"
                        [autoSelectFirst]="true"
                        [showLabel]="false">
                    </app-radio-input>
                    <div class="grid-1-2 flex gap-small align-items-center">
                        <span>{{ 'inputs.rrule.repeatOnDay' | translate }}</span>
                        <app-number-input
                            [form]="innerForm"
                            id="bymonthday"
                            [min]="1"
                            [max]="31"
                            [showLabel]="false">
                        </app-number-input>
                    </div>
                    <div class="grid-2-2 flex gap-small align-items-center">
                        <span>{{ 'inputs.rrule.repeatOnPos' | translate }}</span>
                        <app-multi-select-input
                            #multiselectBySetPos
                            [form]="innerForm"
                            id="bysetpos"
                            [staticOptions]="rruleMonthDayPositionEnumOptions"
                            valueKey="value"
                            [showLabel]="false"
                        >
                            <ng-template #selectedItems let-items>
                                <div class="flex gap-small" style="min-height: 1.5rem;">
                                    @for (item of items; track $index) {
                                        <p-chip [removable]="true"
                                            (onRemove)="multiselectBySetPos.removeItem($event, item)">
                                            <div>{{ item.name }}</div>
                                        </p-chip>
                                    }
                                </div>
                            </ng-template>
                        </app-multi-select-input>

                        <app-multi-select-input
                            #multiselectWeekDay
                            [form]="innerForm"
                            id="byweekday"
                            [staticOptions]="rruleWeekDayEnumOptions"
                            [showLabel]="false"
                            valueKey="value"
                            [showClear]="true"
                        >
                            <ng-template #item let-item>
                                {{ 'inputs.rrule.enum.weekDay.' + RRuleWeekDay[item.value] | translate }}
                            </ng-template>
                            <ng-template #selectedItems let-items>
                                <div class="flex gap-small" style="min-height: 1.5rem;">
                                    @for (item of items; track $index) {
                                        <p-chip [removable]="true"
                                            (onRemove)="multiselectWeekDay.removeItem($event, item)">
                                            <div>{{ item.name }}</div>
                                        </p-chip>
                                    }
                                </div>
                            </ng-template>
                        </app-multi-select-input>
                    </div>
                </div>
            }
            @case (RRuleFrequency.YEARLY) {
                <div class="flex-column gap pt-2">
                    <div class="flex gap-small align-items-center">
                        <span>{{ 'inputs.rrule.repeatOnMonth' | translate }}</span>
                        <app-multi-select-input
                            #multiselectWeekDay
                            [form]="innerForm"
                            id="bymonth"
                            [staticOptions]="rruleMonthNameEnumOptions"
                            [showLabel]="false"
                            valueKey="value"
                            [showClear]="true"
                        >
                            <ng-template #selectedItems let-items>
                                <div class="flex gap-small" style="min-height: 1.5rem;">
                                    @for (item of items; track $index) {
                                        <p-chip [removable]="true"
                                            (onRemove)="multiselectWeekDay.removeItem($event, item)">
                                            <div>{{ item.name }}</div>
                                        </p-chip>
                                    }
                                </div>
                            </ng-template>
                        </app-multi-select-input>
                    </div>

                    <div class="grid-container">
                        <app-radio-input
                            [form]="innerForm"
                            id="type"
                            layout="vertical"
                            class="fh-2"
                            [staticOptions]="monthlyTypeOptions"
                            [autoSelectFirst]="true"
                            [showLabel]="false">
                        </app-radio-input>
                        <div class="grid-1-2 flex gap-small align-items-center">
                            <span>{{ 'inputs.rrule.repeatOnDay' | translate }}</span>
                            <app-number-input
                                [form]="innerForm"
                                id="bymonthday"
                                [min]="1"
                                [max]="31"
                                [showLabel]="false">
                            </app-number-input>
                        </div>
                        <div class="grid-2-2 flex gap-small align-items-center">
                            <span>{{ 'inputs.rrule.repeatOnPos' | translate }}</span>
                            <app-multi-select-input
                                #multiselectBySetPos
                                [form]="innerForm"
                                id="bysetpos"
                                [staticOptions]="rruleMonthDayPositionEnumOptions"
                                valueKey="value"
                                [showLabel]="false"
                            >
                                <ng-template #selectedItems let-items>
                                    <div class="flex gap-small" style="min-height: 1.5rem;">
                                        @for (item of items; track $index) {
                                            <p-chip [removable]="true"
                                                (onRemove)="multiselectBySetPos.removeItem($event, item)">
                                                <div>{{ item.name }}</div>
                                            </p-chip>
                                        }
                                    </div>
                                </ng-template>
                            </app-multi-select-input>

                            <app-multi-select-input
                                #multiselectByDay
                                [form]="innerForm"
                                id="byweekday"
                                [staticOptions]="rruleWeekDayEnumOptions"
                                [showLabel]="false"
                                valueKey="value"
                                [showClear]="true"
                            >
                                <ng-template #item let-item>
                                    {{ 'inputs.rrule.enum.weekDay.' + RRuleWeekDay[item.value] | translate }}
                                </ng-template>
                                <ng-template #selectedItems let-items>
                                    <div class="flex gap-small" style="min-height: 1.5rem;">
                                        @for (item of items; track $index) {
                                            <p-chip [removable]="true"
                                                (onRemove)="multiselectByDay.removeItem($event, item)">
                                                <div>{{ item.name }}</div>
                                            </p-chip>
                                        }
                                    </div>
                                </ng-template>
                            </app-multi-select-input>
                        </div>
                    </div>
                </div>
            }
        }

        <div class="flex gap-small align-items-center">
            <span>{{ 'inputs.rrule.enum.end.label' | translate }}</span>
            <app-select-input
                [form]="innerForm"
                id="endtype"
                [staticOptions]="rruleEndEnumOptions"
                [showLabel]="false"
                valueKey="value"
                [showClear]="false"
            ></app-select-input>

            <div class="flex align-items-center">
                @if (innerForm.value.endtype !== RRuleEnd.NEVER) {
                    @switch (innerForm.value.endtype) {
                        @case (RRuleEnd.UNTIL) {
                            <app-date-input
                                [form]="innerForm"
                                id="until"
                                [showLabel]="false"
                                [disabled]="disabled()"
                            ></app-date-input>
                        }
                        @case (RRuleEnd.COUNT) {
                            <div class="flex gap-small align-items-center">
                                <app-number-input
                                    [form]="innerForm"
                                    id="count"
                                    [showLabel]="false"
                                ></app-number-input>
                                <span>
                                    {{ 'inputs.rrule.enum.end.occurrences' | translate }}
                                </span>
                            </div>
                        }
                    }
                }
            </div>
        </div>
    } @else {
        <div class="flex gap-small align-items-center">
            <div>
                {{ 'inputs.rrule.enum.frequency.label' | translate }} {{ 'inputs.rrule.repeatEvery' | translate }} x
            </div>
            <app-select-input
                [form]="innerForm"
                id="freq"
                [staticOptions]="rruleFrequencyEnumOptions"
                [showLabel]="false"
                valueKey="value"
                [showClear]="true"
            ></app-select-input>
        </div>
    }
</div>
<small [id]="id() + '-help'">{{ form().controls?.[id()]?.value | formatRRule }}</small>
